var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page-outline", {
    attrs: { title: _vm.$t("Webheader.faqs") },
    scopedSlots: _vm._u([
      {
        key: "pageContent",
        fn: function () {
          return [
            !_vm.hasLinks
              ? _c("b-container", { attrs: { fluid: "" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.$t("faq.no_file")))]),
                ])
              : _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { md: "3" } }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("faq.download_files.userguide"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.links.userguide
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(_vm.links.userguide)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.user_guide"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.testcaselist
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.testcaselist
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.testcaselist"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.onboardingguide
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.onboardingguide
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.onboardingguide"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { md: "5" } }, [
                          _c("h5", [
                            _vm._v(_vm._s(_vm.$t("faq.download_files.video"))),
                          ]),
                          _vm._v(" "),
                          _vm.links.videoSettingID
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoSettingID
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoSettingID"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoresponderconf1
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoresponderconf1
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoresponderconf1"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoresponderconf2
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoresponderconf2
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoresponderconf2"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoresponderconf
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoresponderconf
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoresponderconf"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoRequesterTestCase
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoRequesterTestCase
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoRequesterTestCase"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoResponderTesCase
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoResponderTesCase
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoResponderTesCase"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoWiewRequests
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoWiewRequests
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoWiewRequests"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoTestReport
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videoTestReport
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videoTestReport"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videotestsession
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.videotestsession
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.videotestsession"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.videoFAQ
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(_vm.links.videoFAQ)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-video-o",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("faq.download_files.videoFAQ")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { md: "4" } }, [
                          _c("h5", [
                            _vm._v(
                              _vm._s(_vm.$t("faq.download_files.examplesfiles"))
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.links.requestertestdataimportexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links
                                            .requestertestdataimportexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.requestertestdataimportexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.respondertestdataimportexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links
                                            .respondertestdataimportexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.respondertestdataimportexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.voprequestbicexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.voprequestbicexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.voprequestbicexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.voprequestidexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.voprequestidexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.voprequestidexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.voprequestleiexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.voprequestleiexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.voprequestleiexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.links.voprequestnameexemple
                            ? _c("div", [
                                _c(
                                  "label",
                                  {
                                    staticClass: "cursor",
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUri(
                                          _vm.links.voprequestnameexemple
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-file-text",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "faq.download_files.voprequestnameexemple"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }